export default {
    state: {
      messages: []
    },
    mutations: {
      pushMessage(state, message) {
        state.messages = [...state.messages, message]
      },
      popMessage(state, id) {
        state.messages = state.messages.filter(el => el.id != id)
      }
    },
    actions: {
      async throwMessage({commit}, { text, message_class, resolver }) {
        let id = Math.random() * 999999999999999
  
        let resolve = async (data) => {
          if (resolver) {
            await resolver(id, data)
          }
  
          await commit('popMessage', id)
        }
  
        await commit('pushMessage', {
          id,
          text,
          message_class,
          resolve
        })
  
        return resolve
      },
      async throwTimeoutMessage({dispatch}, {text, message_class, resolver, timeout = 5000}) {
        let resolve = await dispatch('throwMessage', {text, message_class, resolver})
  
        return new Promise(r => setTimeout(() => {resolve(); r();}, timeout))
      }
    },
    getters: {
      messages(state){
        return state.messages
      }
    }
  }